import { useTheme } from '@mui/material';
const useLanguageStyles = () => {
    const theme = useTheme();
    const headerHeight = '48px';
    const bottomNavigationHeight = '56px';
    return {
        languageSectionStyles: {
            display: 'flex',
            flexDirection: 'column',
            p: 2,
            height: `calc(100dvh - ${headerHeight} - ${bottomNavigationHeight})`,
            overflowY: 'auto',
            position: 'relative'
        },
        languageHeaderStyles: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
        imageStyles: {
            maxWidth: '36px',
            width: '100%',
            height: '26px',
            objectFit: 'cover'
        },
        languageTileContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            my: 5,
            gap: 2
        },
        languageTileStyles: {
            display: 'flex',
            alignItems: 'center',
            p: 1.5,
            gap: 2,
            borderRadius: 1,
        }
    };
};
export default useLanguageStyles;
